import { Component, computed, inject, input, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Button } from 'primeng/button';
import { Tag } from 'primeng/tag';
import { Tooltip } from 'primeng/tooltip';
import { Message } from 'primeng/message';
import { Company } from '@/lib-backend';

@Component({
    selector: 'app-website-info-stripe',
    standalone: true,
    imports: [Button, Tag, Tooltip, Message],
    templateUrl: './stripe-tab.html',
})
export class StripeTab {
    private readonly router = inject(Router);

    readonly company = input<Company | null>(null);

    protected readonly stripe = computed(() => this.company()?.Stripe ?? null);
    protected readonly enabled = computed(() => this.stripe()?.IsEnabled === true);

    protected readonly webhookUrl = `${window.location.origin}/api/payment/stripeWebhook`;

    protected readonly copiedField = signal<string | null>(null);

    protected mask(value: string | undefined): string {
        if (!value) return '—';
        if (value.length <= 4) return '•'.repeat(value.length);
        return '••••••••' + value.slice(-4);
    }

    protected async copy(field: string, value: string): Promise<void> {
        if (!value) return;
        try {
            await navigator.clipboard.writeText(value);
            this.copiedField.set(field);
            setTimeout(() => {
                if (this.copiedField() === field) this.copiedField.set(null);
            }, 1500);
        } catch {
            // Clipboard write can fail in non-secure contexts; silent.
        }
    }

    protected goToCompanies(): void {
        const c = this.company();
        const queryParams = c ? { edit: c.Id } : undefined;
        this.router.navigate(['/companies'], { queryParams });
    }
}
